import { Controller, useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import type { QuizEditFormStateType } from 'types/page/quizEditFormStateType';

import type { JSX } from 'react';

/**
 * クイズ作成編集 正解選択肢指定コンポーネント
 */
export default function WsQuizEditQuestionOptionCorrectButton(props: {
  // 設問インデックス
  questionIndex: number;
  // 選択肢インデックス
  optionIndex: number;
  // フォームコントロール
  control: Control<QuizEditFormStateType>;
  // 読み取り専用
  readOnly?: boolean;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  const { control, getValues } = useFormContext<QuizEditFormStateType>();

  const { update } = useFieldArray({
    control,
    name: `questions.${props.questionIndex}.options`,
  });

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */
  const value = useWatch({
    control: props.control,
    name: `questions.${props.questionIndex}.options.${props.optionIndex}.correctFlag`,
  });
  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /**
   * 正解を設定します。。
   */
  const onSetCorrect = (optionIndex: number) => {
    if (props.readOnly) return;

    const values = getValues();
    const options = values.questions[props.questionIndex].options;

    options.forEach((option, index) => {
      option.correctFlag = optionIndex === index;
      update(index, option);
    });
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <Controller
        name={`questions.${props.questionIndex}.options.${props.optionIndex}.correctFlag`}
        control={control}
        defaultValue={false}
        render={() => {
          return (
            <>
              <button
                onClick={() => onSetCorrect(props.optionIndex)}
                className={`btn btn-star ${value ? 'is-active' : ''}`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28.169"
                  height="28.155"
                  viewBox="0 0 28.169 28.155"
                  className="icon-star"
                >
                  <path
                    d="M14.337.534l4.005,7.935,7.709.764a.964.964,0,0,1,.6,1.645l-6.344,6.288,2.352,8.544a.973.973,0,0,1-1.378,1.119l-7.815-3.87-7.8,3.865A.973.973,0,0,1,4.282,25.7L6.634,17.16.285,10.872a.964.964,0,0,1,.6-1.645l7.709-.764,4-7.93a.98.98,0,0,1,1.745,0Z"
                    transform="translate(0.617 0.6)"
                    fill="#ffd56d"
                    stroke="#ffd56d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="1.2"
                  />
                </svg>
              </button>
            </>
          );
        }}
      />
    </>
  );
}
